/**
 * Safe Swym Cart Integration
 * Updates cart counter after Swym / cart-add flows without polling /cart.js on an interval
 * (interval + burst timeouts caused many sequential cart.js requests and hurt Lighthouse).
 */
(function () {
  'use strict';

  let isUpdating = false;
  let lastCartCount = 0;
  let debounceTimer = null;

  function safeUpdateCartCounter() {
    if (isUpdating) return;
    isUpdating = true;

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (cart.item_count !== lastCartCount) {
          lastCartCount = cart.item_count;

          var cartCountElements = document.querySelectorAll('.thb-item-count');
          cartCountElements.forEach(function (element) {
            var isCartCounter =
              element.closest('a[href*="cart"]') ||
              element.closest('#cart-drawer-toggle') ||
              element.closest('.thb-secondary-cart') ||
              element.closest('[href*="cart"]');

            if (isCartCounter && element.offsetParent !== null) {
              if (cart.item_count > 99) {
                element.innerHTML =
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-3 h-3"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
              } else {
                element.textContent = cart.item_count;
              }
            }
          });
        }
        isUpdating = false;
      })
      .catch(function () {
        isUpdating = false;
      });
  }

  /** Coalesce rapid triggers (Swym triple-timeout, double cart/add hooks) into one fetch. */
  function scheduleCartCounterUpdate(delayMs) {
    var d = delayMs != null ? delayMs : 400;
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      debounceTimer = null;
      safeUpdateCartCounter();
    }, d);
  }

  function setupSwymListener() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (
        target.classList &&
        target.classList.contains('swym-button') &&
        target.textContent &&
        target.textContent.includes('ADDED TO BAG')
      ) {
        scheduleCartCounterUpdate(450);
      }
    });
  }

  function setupCartInterception() {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0];

      if (typeof url === 'string' && url.indexOf('/cart/add.js') !== -1) {
        return originalFetch.apply(this, args).then(function (response) {
          if (response.ok) {
            scheduleCartCounterUpdate(300);
          }
          return response;
        });
      }

      return originalFetch.apply(this, args);
    };

    if (window.jQuery) {
      window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
        if (settings.url && settings.url.indexOf('/cart/add.js') !== -1 && xhr.status === 200) {
          scheduleCartCounterUpdate(300);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    safeUpdateCartCounter();
    setupCartInterception();
    setupSwymListener();

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        scheduleCartCounterUpdate(500);
      }
    });
  });

  window.safeUpdateCartCounter = safeUpdateCartCounter;
})();
